module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-3-4f3c35d02f55b54619b0d9cdde8f7452.png";